module.exports = __webpack_public_path__ + "823753bf534742dd44a2af1369d8f8e7.png";